import Icon from '@mdi/react'

const cottageSvg = `M12 3 6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h7v-6h2v6h7v-9.38l1.79 1.36L23 11.4zm-2-2c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1z`
const cottageOutlinedSvg = `M12 3 6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4zm6 16h-5v-4h-2v4H6v-8.9l6-4.58 6 4.58zM10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1z`

interface HomeProps {
    color?: string
    filled?: boolean
}

const Home = ({ color, filled }: HomeProps) => (
    <Icon
        path={filled ? cottageSvg : cottageOutlinedSvg}
        size={1}
        color={color}
    />
)

export default Home
